import { render, staticRenderFns } from "./painel-deliberacao.vue?vue&type=template&id=6c6c0d98&scoped=true&"
import script from "./painel-deliberacao.vue?vue&type=script&lang=js&"
export * from "./painel-deliberacao.vue?vue&type=script&lang=js&"
import style0 from "./painel-deliberacao.vue?vue&type=style&index=0&id=6c6c0d98&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6c0d98",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VExpandTransition,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c6c0d98')) {
      api.createRecord('6c6c0d98', component.options)
    } else {
      api.reload('6c6c0d98', component.options)
    }
    module.hot.accept("./painel-deliberacao.vue?vue&type=template&id=6c6c0d98&scoped=true&", function () {
      api.rerender('6c6c0d98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/painel-deliberacao/painel-deliberacao.vue"
export default component.exports